import { render, staticRenderFns } from "./emptyRequests.vue?vue&type=template&id=8749ec6a&scoped=true"
import script from "./emptyRequests.vue?vue&type=script&lang=js"
export * from "./emptyRequests.vue?vue&type=script&lang=js"
import style0 from "./emptyRequests.vue?vue&type=style&index=0&id=8749ec6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8749ec6a",
  null
  
)

export default component.exports